// removed by extract-text-webpack-plugin
module.exports = {"SymbolPriceDepth":"SymbolPriceDepth","Cell":"Cell","Header":"Header","ag-header-cell-label":"ag-header-cell-label","ag-header-group-cell-label":"ag-header-group-cell-label","ag-header-row":"ag-header-row","ag-floating-bottom":"ag-floating-bottom","ag-row":"ag-row"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/SymbolPriceDepth/styles.scss
// module id = 815
// module chunks = 10